import React from 'react';

interface IProps {
  color: string;
  scale?: number;
}

const CrownIcon = ({ color, scale = 1 }: IProps) => (
  <svg width={10 * scale} height={11 * scale} viewBox={`0 0 10 11`}>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0H10V10H0z" transform="translate(0 .41)" />
      <path
        fill={color || '#4051B5'}
        d="M5 2.917l1.667 2.916 2.5-2.083-.834 5.417H1.667L.833 3.75l2.5 2.083L5 2.917zM.833 1.25c.46 0 .834.373.834.833 0 .46-.373.834-.834.834-.46 0-.833-.373-.833-.834 0-.46.373-.833.833-.833zm8.334 0c.46 0 .833.373.833.833 0 .46-.373.834-.833.834-.46 0-.834-.373-.834-.834 0-.46.373-.833.834-.833zM5 .556c.46 0 .833.373.833.833 0 .46-.373.833-.833.833-.46 0-.833-.373-.833-.833 0-.46.373-.833.833-.833z"
        transform="translate(0 .41)"
      />
    </g>
  </svg>
);

export default CrownIcon;
